var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"f-editable-table__column-resizer",style:({height: _vm.height})})
}
var staticRenderFns = []

export { render, staticRenderFns }